import { useContext } from "react";
import { DialogContext } from "../provider";

export const useDialog = () => {
    return useContext(DialogContext);
  };

  export default useDialog;